const siteConfig = {
  title: "Norhart",
  titleTemplate: "%s | Norhart",
  description: "Placeholder",
  url: process.env.NORHART_SITE_URL || "https://www.norhart.com",
  siteUrl: process.env.NORHART_SITE_URL || "https://www.norhart.com",
  shareImageWidth: 1000,
  shareImageHeight: 523,
  siteIcon: "favicon.png",
}

/** export */
export default siteConfig
